export default __webpack_public_path__ + "static/media/kentucky.525cd266.jpg";